/* eslint-disable node/no-missing-import */
/* eslint-disable jsx-a11y/anchor-is-valid */
// Copyright (c) 2015-present, salesforce.com, inc. All rights reserved

import React from 'react';
import { useIntl } from 'react-intl';

import PropTypes from 'prop-types';
import { MESSAGE_RESTORE_FAILURE, MESSAGE_RESTORE_SUCCESS_ONE, MESSAGE_RESTORE_SUCCESS_TWO } from '../../constants/constants';

function RestoreResponse ({ ...props }) {
	const { restoreStatus } = props;
	const intl = useIntl();

	const successText = intl.formatMessage({
		id: 'messages.RESTORE_SUCCESS',
		defaultMessage: MESSAGE_RESTORE_SUCCESS_ONE + MESSAGE_RESTORE_SUCCESS_TWO
	});

	const failureText = intl.formatMessage({
		id: 'messages.RESTORE_FAILURE',
		defaultMessage: MESSAGE_RESTORE_FAILURE.replace('{requestId}', restoreStatus.requestId)
	}, { requestId: restoreStatus.requestId });

	const successMessage = (
		<div className="slds-text-body_medium slds-grid slds-gutters">
			<div className="slds-col">
				<span className="slds-icon_container slds-icon_container_circle slds-icon-action-approval">
					<svg aria-hidden="true" className="slds-icon slds-icon_large">
						<use xlinkHref="/assets/icons/action-sprite/svg/symbols.svg#approval" />
					</svg>
				</span>
			</div>
			<div className="slds-col slds-align_absolute-center">
				{successText}
			</div>
		</div>
	);
	// eslint-disable-next-line react/destructuring-assignment
	const failedMessage = (
		<div className="slds-text-body_medium slds-grid slds-gutters">
			<div className="slds-col">
				<span className="slds-icon_container slds-icon_container_circle slds-icon-action-close">
					<svg aria-hidden="true" className="slds-icon slds-icon_large">
						<use xlinkHref="/assets/icons/action-sprite/svg/symbols.svg#close" />
					</svg>
				</span>
			</div>
			<div className="slds-col slds-align_absolute-center">
				{failureText}
			</div>
		</div>
	);

	return (
		<div className="slds-align_absolute-center slds-p-around_xx-large">
			{ restoreStatus.status === 'success' ? (
				successMessage
			) : failedMessage}
		</div>
	);
}

RestoreResponse.propTypes = {
	restoreStatus: PropTypes.object.isRequired
};

export default RestoreResponse;
